import { useEffect, useState } from 'react';
import { IS_LOCAL_DEV } from 'src/constants/envs';
import type { tAlertSnapshotOverride } from './AlertCenter.types';
import {
  ALERT_SNAPSHOT_OVERRIDE_STORAGE_KEY,
  readAlertSnapshotOverride,
  subscribeAlertSnapshotOverride,
} from './AlertSnapshotOverride.store';

/**
 * Subscribes to the simulator override store. Always `null` when
 * `!IS_LOCAL_DEV` — mirrors `useLeadAgentDesignOverride`'s prod-safety
 * contract: no listener is even registered outside local dev.
 */
export function useAlertSnapshotOverride(): tAlertSnapshotOverride | null {
  const [override, setOverride] = useState<tAlertSnapshotOverride | null>(
    () => readAlertSnapshotOverride(),
  );

  useEffect(() => {
    if (!IS_LOCAL_DEV) return undefined;

    function refresh() {
      setOverride(readAlertSnapshotOverride());
    }
    function handleStorage(event: StorageEvent) {
      if (event.key === ALERT_SNAPSHOT_OVERRIDE_STORAGE_KEY) refresh();
    }

    const unsubscribe = subscribeAlertSnapshotOverride(refresh);
    window.addEventListener('storage', handleStorage);
    return () => {
      unsubscribe();
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  return override;
}
